var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 317.39,
    height: 275.46,
    viewBox: "0 0 317.39 275.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_714",
    "data-name": "Grupo 714",
    transform: "translate(-971.005 -205.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_security_re_a2rk",
    transform: "translate(971.045 205.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14762",
    "data-name": "Trazado 14762",
    d: "M839.179,656.676l8.549-2.712a28.938,28.938,0,0,0-.206-13.922c-3.435,7.637-13.511,9.508-19.253,15.6a17.407,17.407,0,0,0-4.453,14.415l-1.8,6.1a29.167,29.167,0,0,0,21.228-12.075,28.163,28.163,0,0,0,3.3-6.25C842.9,657.472,839.179,656.676,839.179,656.676Z",
    transform: "translate(-545.353 -401.381)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14763",
    "data-name": "Trazado 14763",
    d: "M827.473,633.655l6.442-6.24a28.938,28.938,0,0,0-6.393-12.369c.332,8.367-7.853,14.536-10.273,22.552a17.405,17.405,0,0,0,2.444,14.888l1.111,6.263a29.167,29.167,0,0,0,13.614-20.275,28.175,28.175,0,0,0,.167-7.066C831.16,632.707,827.473,633.655,827.473,633.655Z",
    transform: "translate(-542.782 -389.642)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14764",
    "data-name": "Trazado 14764",
    d: "M542.211,222.847H301.263a.958.958,0,1,1,0-1.917H542.211a.958.958,0,1,1,0,1.917Z",
    transform: "translate(-300.345 -204.557)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_98",
    "data-name": "Elipse 98",
    cx: 5.615,
    cy: 5.741,
    rx: 5.615,
    ry: 5.741,
    transform: "translate(11.705 0)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_99",
    "data-name": "Elipse 99",
    cx: 5.615,
    cy: 5.741,
    rx: 5.615,
    ry: 5.741,
    transform: "translate(31.103 0)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_100",
    "data-name": "Elipse 100",
    cx: 5.615,
    cy: 5.741,
    rx: 5.615,
    ry: 5.741,
    transform: "translate(50.502 0)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14765",
    "data-name": "Trazado 14765",
    d: "M721.258,192.742h-13.78a1.043,1.043,0,1,0,0,2.087h13.78a1.043,1.043,0,0,0,0-2.087Z",
    transform: "translate(-491.072 -191.319)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14766",
    "data-name": "Trazado 14766",
    d: "M721.259,200.126h-13.78a1.043,1.043,0,1,0,0,2.087h13.78a1.043,1.043,0,0,0,0-2.087Z",
    transform: "translate(-491.072 -194.787)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14767",
    "data-name": "Trazado 14767",
    d: "M721.259,207.5h-13.78a1.043,1.043,0,1,0,0,2.087h13.78a1.043,1.043,0,0,0,0-2.087Z",
    transform: "translate(-491.072 -198.25)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_101",
    "data-name": "Elipse 101",
    cx: 6.942,
    cy: 6.942,
    r: 6.942,
    transform: "translate(11.705 43.335)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14768",
    "data-name": "Trazado 14768",
    d: "M506.178,310.178H324.516a2.067,2.067,0,0,1,0-4.135H506.178a2.067,2.067,0,0,1,0,4.135Z",
    transform: "translate(-310.744 -244.528)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14769",
    "data-name": "Trazado 14769",
    d: "M458.534,325.58H324.516a2.067,2.067,0,1,1,0-4.135H458.534a2.067,2.067,0,1,1,0,4.135Z",
    transform: "translate(-310.744 -251.761)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_102",
    "data-name": "Elipse 102",
    cx: 6.942,
    cy: 6.942,
    r: 6.942,
    transform: "translate(11.705 151.694)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14770",
    "data-name": "Trazado 14770",
    d: "M506.178,514.483H324.516a2.067,2.067,0,0,1,0-4.135H506.178a2.312,2.312,0,0,1,2.182,2.227,2.041,2.041,0,0,1-2.182,1.908Z",
    transform: "translate(-310.744 -340.474)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14771",
    "data-name": "Trazado 14771",
    d: "M458.534,529.885H324.516a2.067,2.067,0,1,1,0-4.135H458.534a2.067,2.067,0,1,1,0,4.135Z",
    transform: "translate(-310.744 -347.707)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_103",
    "data-name": "Elipse 103",
    cx: 6.942,
    cy: 6.942,
    r: 6.942,
    transform: "translate(11.705 93.43)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14772",
    "data-name": "Trazado 14772",
    d: "M506.178,404.629H324.516a2.067,2.067,0,0,1,0-4.135H506.178a2.067,2.067,0,0,1,0,4.135Z",
    transform: "translate(-310.744 -288.884)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14773",
    "data-name": "Trazado 14773",
    d: "M480.881,420.031H324.516a2.067,2.067,0,1,1,0-4.135H480.881a2.067,2.067,0,1,1,0,4.135Z",
    transform: "translate(-310.744 -296.117)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14774",
    "data-name": "Trazado 14774",
    d: "M470.268,435.433H324.516a2.067,2.067,0,1,1,0-4.135H470.268a2.067,2.067,0,0,1,0,4.135Z",
    transform: "translate(-310.744 -303.35)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_104",
    "data-name": "Elipse 104",
    cx: 51.411,
    cy: 51.411,
    r: 51.411,
    transform: "translate(111.128 120.654)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_105",
    "data-name": "Elipse 105",
    cx: 7.345,
    cy: 7.345,
    r: 7.345,
    transform: "translate(155.124 175.314)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_106",
    "data-name": "Elipse 106",
    cx: 3.39,
    cy: 3.39,
    r: 3.39,
    transform: "translate(159.079 179.269)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14775",
    "data-name": "Trazado 14775",
    d: "M599.423,536.325H572.3a10.142,10.142,0,0,1-10.131-10.131V513.758A10.143,10.143,0,0,1,572.3,503.627h27.126a10.142,10.142,0,0,1,10.131,10.131v12.437A10.142,10.142,0,0,1,599.423,536.325ZM572.3,504.687a9.081,9.081,0,0,0-9.07,9.07v12.437a9.08,9.08,0,0,0,9.07,9.07h27.126a9.08,9.08,0,0,0,9.07-9.07V513.758a9.08,9.08,0,0,0-9.07-9.07Z",
    transform: "translate(-423.32 -337.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14776",
    "data-name": "Trazado 14776",
    d: "M573.161,531.918h24.077a9.516,9.516,0,0,0,9.516-9.516V511.994a9.476,9.476,0,0,0-.628-3.376,9.491,9.491,0,0,1,3.782,7.582v10.408a9.516,9.516,0,0,1-9.516,9.516H576.315a9.511,9.511,0,0,1-8.889-6.14A9.463,9.463,0,0,0,573.161,531.918Z",
    transform: "translate(-425.791 -339.661)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14777",
    "data-name": "Trazado 14777",
    d: "M409.179,486.335h-5.916l-2.815-22.82h8.732Z",
    transform: "translate(-188.078 -217.676)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14778",
    "data-name": "Trazado 14778",
    d: "M701.538,699.531H683.344v-.23a7.082,7.082,0,0,1,7.081-7.081h0l3.323-2.521,6.2,2.522h1.588Z",
    transform: "translate(-480.228 -424.7)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14779",
    "data-name": "Trazado 14779",
    d: "M495.837,486.335h5.916l2.815-22.82h-8.732Z",
    transform: "translate(-232.874 -217.676)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14780",
    "data-name": "Trazado 14780",
    d: "M795.79,699.531h18.193v-.23a7.082,7.082,0,0,0-7.081-7.081h0l-3.323-2.521-6.2,2.522h-1.588Z",
    transform: "translate(-533.035 -424.7)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14781",
    "data-name": "Trazado 14781",
    d: "M700.292,555.643c.087-1.3.782-8.5.782-8.5l1.664-15.272,2.933-40.483.191-2.65,15.364-2.95,10.5-5.034,12.48,3.99,9.718,3.644s.017,1.56.092,3.445c.1,2.467.274,5.491.69,6.278.695,1.39.52,8.849.52,8.849s.69,15.176,1.56,16.84a11.561,11.561,0,0,1,.782,5.824c-.262.695.869,18.921.869,18.921s2.9,32.253,1.082,37.116-8.708,1.678-8.708,1.678.333-1.3-1.664-1.91-8.079-46.344-8.079-46.344-1.131-9.377-2.172-12.065-2-10.238-2-10.238-6.423-12.5-6.506-15.276c0,0-.84-2.6-1.635.262s-3.137,9.718-3.137,9.718l-2.284,8.42-2.688,12.581-1.739,10.592s-2.6,14.057-3.02,14.665,0,13.45,0,13.45-2.014,10.937-4.859,12.847-10.385.03-10.385.03S700.2,556.945,700.292,555.643Z",
    transform: "translate(-488.182 -326.575)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14782",
    "data-name": "Trazado 14782",
    d: "M408.878,200.171l3.416,10.288-4.214,5.017,1.856,1.91-1.369,2.7-3.57,28.3,19.569,7.422,6.59-8.262,5.2,8.262L459,250.272l-5.775-36.085v-2.359l-1.63-4.555v-9.643l4.306-28.705-12.851-4.5-4.061-1.261-4.071,3.238-8.466-1.506-1.525-1-5.173,1.981-5.454,1.556-6.531,1.494-.832,2.08,1.664-.416-.27,27.062Z",
    transform: "translate(-190.214 -74.932)",
    fill: "#426d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14783",
    "data-name": "Trazado 14783",
    d: "M695.023,455.929l3.287-31.813.868-13.093-9.2-1.663s.365,9.362-.841,14.644c-1.189,5.212-.158,31.227-.084,31.923a4.476,4.476,0,1,0,5.97,0Z",
    transform: "translate(-482.209 -293.047)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14784",
    "data-name": "Trazado 14784",
    d: "M684.1,409.621l2.559.528,8.778,1.818.487.1,1.036-4.118,1.2-1.281,2.288-11.99.121-.624,3.457-7.389,2.392-22.207-8.894,1.6c-.046.046-.087.1-.129.146-1.277,1.448-2.188,3.461-3.678,5.487-4.847,6.594-8.566,22.615-8.42,31.393,0,.141-.141.3-.316.453a4.869,4.869,0,0,0-.882,6.086Z",
    transform: "translate(-480.258 -271.961)",
    fill: "#426d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14785",
    "data-name": "Trazado 14785",
    d: "M805.775,455.929l-3.287-31.813-.867-13.093,9.2-1.663s-.364,9.362.841,14.644c1.189,5.212.158,31.227.084,31.923a4.476,4.476,0,1,1-5.97,0Z",
    transform: "translate(-535.773 -293.047)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14786",
    "data-name": "Trazado 14786",
    d: "M808.727,409.621l-2.559.528-8.778,1.818-.487.1-1.036-4.118-1.2-1.281-2.288-11.99-.121-.624-3.457-7.389.79-22.207,5.712,1.6c.046.046.087.1.129.146,1.277,1.448,2.188,3.461,3.677,5.487,4.847,6.594,8.566,22.615,8.42,31.393,0,.141.142.3.316.453A4.869,4.869,0,0,1,808.727,409.621Z",
    transform: "translate(-529.752 -271.961)",
    fill: "#426d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14787",
    "data-name": "Trazado 14787",
    d: "M730.862,360.775l4.179-10.961,10.675-.2,3.542,11.157L761.99,431.9s-39.006,10.862-38.61-2.195c.416-13.729,2.293-31.965,2.293-31.965Z",
    transform: "translate(-499.029 -264.992)",
    fill: "#426d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14789",
    "data-name": "Trazado 14789",
    d: "M765.979,707.676a.629.629,0,0,1-.631.631H616.688a.631.631,0,0,1,0-1.262h148.66a.629.629,0,0,1,.631.631Z",
    transform: "translate(-448.629 -432.847)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14790",
    "data-name": "Trazado 14790",
    d: "M597.045,461.922a14.76,14.76,0,0,0-11.951,5.693,15.446,15.446,0,0,1,9.214-2.956c7.787,0,14.122,5.455,14.122,12.159v5.573h2.737v-8.31C611.167,467.376,604.831,461.922,597.045,461.922Z",
    transform: "translate(-434.088 -317.732)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14791",
    "data-name": "Trazado 14791",
    d: "M608.72,484.819H575.88v-9.662c0-7.8,7.366-14.138,16.42-14.138s16.42,6.342,16.42,14.138Zm-31.779-1.061h30.719v-8.6c0-7.211-6.89-13.077-15.359-13.077s-15.359,5.866-15.359,13.077Z",
    transform: "translate(-429.761 -317.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14792",
    "data-name": "Trazado 14792",
    d: "M605.275,484.4H588.455a2.858,2.858,0,0,1-2.854-2.854V477.7c0-5.361,5.053-9.723,11.265-9.723s11.265,4.362,11.265,9.723v3.845A2.857,2.857,0,0,1,605.275,484.4Zm-8.41-15.362c-5.626,0-10.2,3.886-10.2,8.662v3.845a1.8,1.8,0,0,0,1.793,1.794h16.821a1.8,1.8,0,0,0,1.793-1.794V477.7c0-4.777-4.577-8.662-10.2-8.662Z",
    transform: "translate(-434.326 -320.574)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_256",
    "data-name": "Trazado 256",
    d: "M168.906,747.98s10,.477,10.566-9.113c.6-10.211-8.844-11.189-12.855-7.061s-3.269,8.327-3.269,8.327-2.8-2.52-5.846.575c-2.238,2.272-1.083,5.987-1.083,5.987s-5.158-.2-4.677,4.3a10.055,10.055,0,0,0,3.7,6.791Z",
    transform: "translate(1044.898 -480.772)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_257",
    "data-name": "Trazado 257",
    d: "M198.2,937.969l1.04,10.626s2.215,2.867,8.48,2.764c4.667-.077,6.192-1.283,6.192-1.283l-1.172-5.319-1.15-5.186L200.121,938.2Z",
    transform: "translate(1006.461 -653.104)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_258",
    "data-name": "Trazado 258",
    d: "M209.3,939.31a3.508,3.508,0,0,0,.409,1c2.9,5.076,9.509,5.584,12.207,5.562l-1.15-5.186Z",
    transform: "translate(997.283 -654.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_259",
    "data-name": "Trazado 259",
    d: "M172.625,790.033s6.88,12.777,5.405,20.394-8.354,7-12.531,5.9a13.479,13.479,0,0,1-6.265-3.44,5.741,5.741,0,0,1-6.511-1.72c-2.826-3.317-1.6-7.495.492-8.6s4.791.246,4.791.246l-2.334-3.686s6.88-20.272,16.953-9.091",
    transform: "translate(1045.422 -528.018)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_260",
    "data-name": "Trazado 260",
    d: "M169.506,897.3a.461.461,0,0,1-.233-.063l-4.214-2.446a.465.465,0,1,1,.466-.8l4.214,2.446a.465.465,0,0,1-.234.866",
    transform: "translate(1034.051 -616.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_261",
    "data-name": "Trazado 261",
    d: "M169.758,905.75a.464.464,0,0,1-.216-.876l2.144-1.12a.465.465,0,0,1,.43.824l-2.144,1.12a.462.462,0,0,1-.215.053",
    transform: "translate(1030.361 -624.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_262",
    "data-name": "Trazado 262",
    d: "M270.416,828.423a.463.463,0,0,1-.259-.079,2.072,2.072,0,0,0-2.322-.008.465.465,0,0,1-.546-.752,3,3,0,0,1,3.387-.01.465.465,0,0,1-.26.85",
    transform: "translate(949.494 -561.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_263",
    "data-name": "Trazado 263",
    d: "M267.835,867.116a.465.465,0,0,1-.456-.553,7.993,7.993,0,0,0-1.555-6.572.465.465,0,1,1,.687-.626,8.83,8.83,0,0,1,1.78,7.374.464.464,0,0,1-.455.376",
    transform: "translate(950.65 -587.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    "data-name": "Trazado 264",
    d: "M283.555,854.662a.464.464,0,0,1-.464-.444l-.108-2.536a.464.464,0,1,1,.928-.04l.108,2.536a.464.464,0,0,1-.444.484h-.02",
    transform: "translate(936.361 -581.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_265",
    "data-name": "Trazado 265",
    d: "M243.291,858.507a.464.464,0,0,1-.464-.445l-.108-2.536a.465.465,0,0,1,.444-.484.46.46,0,0,1,.484.444l.108,2.536a.464.464,0,0,1-.444.484h-.02",
    transform: "translate(969.656 -584.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_266",
    "data-name": "Trazado 266",
    d: "M183.283,777.734a4.507,4.507,0,0,0-4.015-1.782,5.756,5.756,0,0,0-4.017,2.26s1.6,4.35-1.773,7.074-6.226,2.333-6.226,2.333l-2.705-.676-2.291-3.633,6.766-8.891,9.283-6.125,5.431,4.041Z",
    transform: "translate(1036.174 -512.825)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_267",
    "data-name": "Trazado 267",
    d: "M248.367,908.1a3.9,3.9,0,0,1-3.477-1.906.464.464,0,1,1,.8-.475,3.146,3.146,0,0,0,3.2,1.411.465.465,0,0,1,.177.912,3.929,3.929,0,0,1-.7.057",
    transform: "translate(967.914 -626.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_268",
    "data-name": "Trazado 268",
    d: "M280.822,848.772a4.667,4.667,0,1,1,4.528-4.665,4.6,4.6,0,0,1-4.528,4.665m0-8.4a3.738,3.738,0,1,0,3.6,3.736,3.673,3.673,0,0,0-3.6-3.736",
    transform: "translate(941.895 -571.646)",
    fill: "#deebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_269",
    "data-name": "Trazado 269",
    d: "M218.089,854.766a4.665,4.665,0,1,1,4.665-4.665,4.67,4.67,0,0,1-4.665,4.665m0-8.4a3.736,3.736,0,1,0,3.736,3.736,3.741,3.741,0,0,0-3.736-3.736",
    transform: "translate(993.871 -576.602)",
    fill: "#deebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_270",
    "data-name": "Trazado 270",
    d: "M259.771,866.524a.465.465,0,0,1-.037-.928l3.284-.269a.465.465,0,0,1,.075.926l-3.284.269h-.038",
    transform: "translate(955.941 -593.046)",
    fill: "#deebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_271",
    "data-name": "Trazado 271",
    d: "M173.266,869.009a.464.464,0,0,1-.338-.783c2.5-2.655,7.381-.2,7.588-.1a.465.465,0,0,1-.423.827c-.044-.023-4.468-2.242-6.488-.1a.465.465,0,0,1-.339.146",
    transform: "translate(1027.461 -594.427)",
    fill: "#deebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_272",
    "data-name": "Trazado 272",
    d: "M205.015,995.945a15.01,15.01,0,0,1-9.048-2.976.426.426,0,0,1,.5-.686c7.516,5.522,15.627,1.22,15.708,1.175a.426.426,0,0,1,.408.748,17.494,17.494,0,0,1-7.572,1.74",
    transform: "translate(1008.896 -696.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_273",
    "data-name": "Trazado 273",
    d: "M224.82,832.048a.46.46,0,0,1-.246-.071.465.465,0,0,1-.147-.64,3.339,3.339,0,0,1,4.12-1.508.465.465,0,0,1-.359.857,2.422,2.422,0,0,0-2.973,1.145.464.464,0,0,1-.394.218",
    transform: "translate(984.834 -563.515)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/ChangePassword.3cba4e4eebcd86d009c6e91d88c1db90.svg";
export { ForwardRef as ReactComponent };